export const MAX_PREFETCH_FILMSTRIP_COUNT = 5;
// Opacity value for previous page snapshot images in FilmStrip
export const PREVIOUS_PAGE_FILM_STRIP_OPACITY = 0.3;
/**
 * Snapshot timestamp is not accurate, METRICS_ADJUSTMENT_TIME_PERCENTAGE is percentage value
 * which is used in calculating correction value to get accurate result
 */
export const METRICS_ADJUSTMENT_TIME_PERCENTAGE = 5;

// 15% of FilmStrip is ideal to manage full last snapshot without any cut off
export const FILMSTRIP_SNAPSHOT_ADJUSTMENT_PERCENTAGE = 15;
// y-axis point for FilmStrip chart
export const FILMSTRIP_SNAPSHOT_Y_AXIS_START_POINT = 50;

// Method to calculate width of each durationLine to match chart.
export const calculateDurationLineWidth = (value, maxValue) => ({ width: `${((value / Math.floor(maxValue))) * 97}%` });

export const METRICS_CARD_LIST = [
  'timeToFirstByte',
  'firstPaint',
  'firstContentfulPaint',
  'firstMeaningfulPaint',
  'firstInteractive',
  'domContentLoaded',
  'load',
];
